export const RTC_PREFIX = 'rtc';

export enum ParticipantType {
  Observer = 'observer',
  Participant = 'member',
}
